import { FC, useEffect, useState } from 'react';
import H5Com from '../../components/H5Com';
import IconQuiet from '../../components/IconQuiet';
import PCCom from './PCCom';
import css from './index.module.scss';
import { useLang } from '@/i18n';
import getLocal from '@/app/utils/getLocal';

const TheComp: FC = () => {
    const { t } = useLang('dp3.landing.QuietComfortJp');
    const { locale = 'us' } = getLocal();
    const [isPC, setIsPC] = useState(true);

    const imgArr = [
        {
            img:
                locale === 'cn'
                    ? 'https://websiteoss.ecoflow.com/upload/image/1737789713906/11_1.jpg'
                    : 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1718870818707/c1%20(1).jpg',
        },
        {
            img:
                locale === 'cn'
                    ? 'https://websiteoss.ecoflow.com/upload/image/1737789714430/11_2.jpg'
                    : 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1718867084944/d2%20(1).jpg',
            title: t('img2_title'),
            desc: t('img2_desc'),
        },
    ];

    useEffect(() => {
        setIsPC(window.innerWidth > 1024);
    }, []);

    return (
        <div
            className={`${css['theComp']} dp3-module-box dp3-teaser-G GtmModuleData-section`}
            data-section-id={'dp3-QuietComfortJp'}
            data-section-title={t('title')}
        >
            {isPC ? (
                <PCCom title={t('title')} imgArr={imgArr} subtitle={t('lMsg')} desc={t('rMsg')} tips={t('tips')} titleSvg={<IconQuiet />} hasTitleSvg={true} />
            ) : (
                <H5Com
                    title={t('title')}
                    imgArr={[
                        locale === 'cn'
                            ? 'https://websiteoss.ecoflow.com/upload/image/1737789971207/11_1_M.jpg'
                            : 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1718866940317/c2%20(1).jpg',
                        locale === 'cn'
                            ? 'https://websiteoss.ecoflow.com/upload/image/1737789714254/11_2_M.jpg'
                            : 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1718867037444/d1%20(1).jpg',
                    ]}
                    imgArrInfo={[
                        null,
                        {
                            title: t('img2_title'),
                            desc: t('img2_desc'),
                            titleSvg: <IconQuiet />,
                            hasTitleSvg: true,
                        },
                    ]}
                    subtitle={t('lMsg')}
                    desc={t('rMsg')}
                    tips={t('tips')}
                    cls="dp3-teaser-G"
                />
            )}
        </div>
    );
};

export default TheComp;
